import { useEffect, useState, useRef } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import useOutsideAlerter from "../../../hooks/useOutsideAlerter"
import ls from "localstorage-slim"
import CircleImage from "../component/CircleImg"
import Log from "../../../lib/Log"
import { logOutsIcon, moonIcon, profileIcon } from "../../../constants/icons"
import { defaultUserIcon } from "../../../constants/icons"
import { useTranslation } from "react-i18next"

ls.config.encrypt = true

function NavUserProfileDropDown({ dropBoxStatus = false, className = "" }) {
  const roles =
    ls.get("roles") &&
    JSON.parse(ls.get("roles")).map((role) => {
      return { identifier: role.identifier, name: role.name }
    })

  const memberRoles = JSON.parse(ls.get("memberDetails"))?.roles?.map(
    (role) => {
      return {
        id: role.id,
        role: role.identifier,
      }
    }
  )

  const wrapperRef = useRef(null)
  const { t, i18n } = useTranslation()
  const [colorScheme, setColorScheme] = useState("light")
  const [dropDownToggle, setDropDownToggle] = useState(dropBoxStatus)

  useOutsideAlerter(wrapperRef, setDropDownToggle)
  const userId = ls.get("userid")

  const [memberDetails, setMemberDetails] = useState({})

  const onDropDownClick = (toggle, e) => {
    if (e.target.classList.contains("user-profile")) {
      return setDropDownToggle((dropToggle) => !dropToggle)
    }
    setDropDownToggle(toggle)
  }

  const navigate = useNavigate()
  const { pathname } = useLocation()
  const activeRole = JSON.parse(ls.get("activeRole"))
  const pathRole = pathname.split("/")[1]
  const role = ls.get("role")
  const isTutor =
    role === "tutor" &&
    pathRole === "tutor" &&
    activeRole.identifier === "tutor"
  const isAdmin =
    role === "admin" &&
    pathRole === "admin" &&
    activeRole.identifier === "admin"
  const isLearner =
    role === "learner" &&
    pathRole === "learner" &&
    activeRole.identifier === "apprentice"
  const isAssessor =
    role === "assessor" &&
    pathRole === "assessor" &&
    activeRole.identifier === "assessor"
  const isIQV =
    role === "iqv" && pathRole === "iqv" && activeRole.identifier === "iqv"
  const isEQV =
    role === "eqv" && pathRole === "eqv" && activeRole.identifier === "eqv"

  const currentActiveRole = isTutor
    ? "tutor"
    : isAdmin
    ? "admin"
    : isLearner
    ? "learner"
    : isAssessor
    ? "assessor"
    : isIQV
    ? "iqv"
    : isEQV
    ? "eqv"
    : "superadmin"

  useEffect(() => {
    try {
      const colorScheme = ls.get("color-scheme")

      if (colorScheme) {
        setColorScheme(colorScheme)
        document.documentElement.setAttribute("data-color-mode", colorScheme)
      }
      let memberDetails = JSON.parse(ls.get("memberDetails"))
      setMemberDetails(memberDetails)
    } catch (e) {
      Log.error(e)
    }
  }, [])

  const onThemeChange = (e) => {
    try {
      const checked = e.target.checked
      let colorScheme = checked ? "dark" : "light"
      document.documentElement.setAttribute("data-color-mode", colorScheme)
      setColorScheme(colorScheme)
      ls.set("color-scheme", colorScheme)
    } catch (e) {
      Log.error(e)
    }
  }

  let dropDownClasses = "dropdown-menu mw-dropdown-default dropdown-menu-end"
  if (dropDownToggle) {
    dropDownClasses += " show"
  }

  const handleLogout = (e) => {
    e.preventDefault()
    localStorage.removeItem("accessToken")
    navigate(`/admin/login`)
  }
  return (
    <div
      ref={wrapperRef}
      className={`dropdown dropdown-select profile-user-dropdown ${className}`}
      onClick={onDropDownClick.bind(null, true)}
    >
      <div
        data-testid='profileicon'
        className='circle-wrap circle-wrap-md bg-profile-color user-profile'
        data-bs-toggle='dropdown'
        data-bs-offset='0,7'
        aria-expanded={dropDownToggle}
      >
        <CircleImage
          src={memberDetails?.profile_image}
          title=''
          defaultIcon={defaultUserIcon}
        />
      </div>
      <ul
        data-testid='profiledropdown'
        className={dropDownClasses}
        aria-labelledby='dropdownMenuButton1'
        data-bs-popper='none'
      >
        {/* <li>
          <a
            className="dropdown-item"
            // href={`/${currentActiveRole}/view-profile/${encryptData(userId)}`}
          >
            {profileIcon}
            <span title={` ${t('Profile')}`}>{` ${t('Profile')}`}</span>
          </a>
        </li> */}

        <li>
          <div className='d-grid align-items-center py-2 mode-switcher dropdown-item'>
            {moonIcon}
            <span className='mx-1'>{t("Dark")} </span>
            <label className='form-switch'>
              <input
                type='checkbox'
                data-testid='themeswitcher'
                checked={colorScheme === "dark"}
                onChange={onThemeChange}
              />
              <span className='form-switch-slider'></span>
            </label>
          </div>
        </li>
        <li>
          <hr className='dropdown-divider' />
        </li>
        <li>
          <a className='dropdown-item' href='#' onClick={handleLogout}>
            {logOutsIcon}
            {` ${t("Log out")}`}
          </a>
        </li>
      </ul>
    </div>
  )
}

export default NavUserProfileDropDown
